import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { appStore, completeTriangleLeftFooter, completeTrianglePost, googlePlay, logo, LogoEn, triangleLeftFooter, trianglepost, vectorLeft, vectorRight } from '../../assets/icons';
import { Lang } from '../../helpers/contents';
import { languageAr, userToken } from '../../helpers/helper';
import i18n from '../../languages/i18n';
const ServicesCard = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <div className="bg-[#E1E9FF] rounded-lg p-10 w-[90%] ml-auto mr-auto my-16 relative">
      <div className="flex">
        <img src={i18n.language == Lang.ar ? logo : LogoEn} />
      </div>
      <div className="grid md:grid-cols-2 xl:grid-cols-4 2xl:grid-cols-4 lg:grid-cols-4 sm:grid-cols-1 mt-10 w-[70%]">
        <div>
          <div className="text-[15px] text-[#444444] cursor-pointer hover:underline font-400"
          onClick={() => navigate('/about-us')}
          >
            {t('home.services.aboutUs')}
          </div>
          <div
            className="text-[15px] text-[#444444] mt-3 cursor-pointer hover:underline font-400"
            onClick={() => navigate('/')}
          >
            {t('home.services.services')}
          </div>
        </div>
        <div className="max600:mt-5">
        <div
            className="text-[15px] text-[#444444] cursor-pointer hover:underline font-400"
            onClick={() => navigate('/privacy')}
          >
            {t('home.services.privacy')}
          </div>
          <div
            className="text-[15px] text-[#444444] mt-3 cursor-pointer hover:underline font-400"
            onClick={() => navigate('/contact-us')}
          >
            {t('home.services.contactUs')}
          </div>
        </div>
        <div>
        <div
            className="text-[15px] text-[#444444] cursor-pointer hover:underline font-400"
            onClick={() => navigate('/terms')}
          >
            {t('home.services.terms')}
          </div>
        </div>
        <div className="max600:mt-5">
          <div className="text-[15px] text-[#444444] font-700">
            {t('home.services.downloadApp')}
          </div>
          <div className="mt-5 flex min600:flex-row max600:flex-col max800:flex-col items-center">
            <img
              src={googlePlay}
              className="cursor-pointer"
              onClick={() =>
                window.open(
                  'https://play.google.com/store/apps/details?id=com.miso.mshraiB2C',
                  '_blank',
                  'noopener,noreferrer'
                )
              }
            />
            <img
              src={appStore}
              className="cursor-pointer"
              onClick={() =>
                window.open(
                  'https://apps.apple.com/eg/app/%D9%85%D8%B4%D8%B1%D8%A7%D9%8A/id6553995179',
                  '_blank',
                  'noopener,noreferrer'
                )
              }
            />
          </div>
        </div>
      </div>
      <img src={languageAr ? triangleLeftFooter : trianglepost} className={languageAr ?  'absolute left-0 bottom-0': 'absolute right-0 bottom-0' }/>
      <img src={languageAr ? completeTriangleLeftFooter : completeTrianglePost} className={languageAr ? 'absolute left-0.5 bottom-0' : 'absolute right-0.5 bottom-0' }/>
      <img
            src={languageAr ? vectorLeft : vectorRight}
            className={languageAr ? "vectorLeft absolute left-10 top-10 z-10" :  "vectorRight absolute right-10 top-10 z-10"}
          />
    </div>
  );
};

export default ServicesCard;
